import {EventEmitter} from 'events';
import { Logger } from '../logger/Logger';

const logger = new Logger('AudioPlayer');

export default class AudioPlayer extends EventEmitter {
  constructor(src, video) {
    super();
    video.pause();
    video.volume = 0;
    this._video = video;
    this._audio = new Audio();
    this._addVideoListeners();
    this._addAudioListeners();
    this.setSrc(src);
  }

  setSrc(src) {
    this._pauseVideo();
    const { volume, playbackRate } = this._audio;
    this._audio.src = src;
    this._audio.volume = volume;
    this._audio.playbackRate = playbackRate;
  }

  setVolume(value) {
    this._audio.volume = value;
  }

  destroy() {
    this._removeVideoListeners();
    this._removeAudioListeners();
    this._video.pause();
    this._audio.pause();
  }

  _addVideoListeners() {
    this._video.addEventListener('play', this._onVideoPlay);
    this._video.addEventListener('pause', this._onVideoPause);
    this._video.addEventListener('seeking', this._onVideoSeeking);
    this._video.addEventListener('ratechange', this._onVideoRateChange);
  }

  _removeVideoListeners() {
    this._video.removeEventListener('play', this._onVideoPlay);
    this._video.removeEventListener('pause', this._onVideoPause);
    this._video.removeEventListener('seeking', this._onVideoSeeking);
    this._video.removeEventListener('ratechange', this._onVideoRateChange);
  }

  _addAudioListeners() {
    this._audio.addEventListener('canplay', this._onAudioCanPlay);
    this._audio.addEventListener('waiting', this._onAudioWaiting);
  }

  _removeAudioListeners() {
    this._audio.removeEventListener('canplay', this._onAudioCanPlay);
    this._audio.removeEventListener('canplay', this._onAudioWaiting);
  }

  _onAudioCanPlay = () => {
    logger.debug('[_onAudioCanPlay()]');
    this._ready = true;
    this.emit('ready');
  }

  _onAudioWaiting = () => {
    logger.debug('[_onAudioWaiting()]');
    this._ready = false;
  }

  _onVideoPlay = () => {
    if (this._ready) {
      logger.debug('[_onVideoPlay()] ready');
      this._syncCurrentTime();
      this._audio.play();
    } else {
      logger.debug('[_onVideoPlay()] waiting for ready');
      this.once('ready', this._onVideoPlay);
    }
  }

  _onVideoPause = () => {
    logger.debug('[_onVideoPause()]');
    this._audio.pause();
  }

  _onVideoSeeking = () => {
    logger.debug('[_onVideoSeeking()]');
    this._audio.pause();
    this._syncCurrentTime();
  }

  _onVideoRateChange = () => {
    this._audio.playbackRate = this._video.playbackRate;
  }

  _syncCurrentTime() {
    logger.debug('[_syncCurrentTime()] video currentTime: ', this._video.currentTime);
    logger.debug('[_syncCurrentTime()] audio currentTime before sync: ', this._audio.currentTime);
    this._audio.currentTime = this._video.currentTime;
    logger.debug('[_syncCurrentTime()] audio currentTime after sync: ', this._audio.currentTime);
  }

  _playVideo() {
    this._video.play();
  }

  _pauseVideo() {
    this._video.pause();
    this.once('ready', this._playVideo.bind(this));
  }

}